module.exports = __webpack_public_path__ + "static/starduckonesie-4cc68f3282e847f4210ac8b5846222f9.jpeg";